export enum Roles {
  PAC = "Paciente",
  PSI = "Psicologo",
  MED = "Médico de família",
  ENF = "Enfermeiro",
  GES = "Gestor",
  ADM = "Administrador",
  ADE = "Administrador Empresa",
  TEE = "Técnico de Enfermagem",
  REC = "Recepcionista",
  NUT = "Nutricionista",
}

export const getDescricaoByCodigo = (codigo: string) => {

  const values: string[] = Object.values(Roles);
  const keys: string[] = Object.keys(Roles);

  const index = keys.indexOf(codigo);
  return values[index];
};

export const getCodigoByDescricao = (desc: string) => {
  const values: string[] = Object.values(Roles);
  const keys: string[] = Object.keys(Roles);

  const index = values.indexOf(desc);
  return keys[index];
};
